import React from "react";
import { DropTarget } from "react-dnd";
import PropTypes from "prop-types";

const CampaignTileDroppable = ({ connectDropTarget, children }) => {
  return connectDropTarget(<div>{children}</div>);
};

const AssetTarget = {
  drop(props, monitor) {
    props.onDrop(monitor.getItem(), props.campaign.id);
  },
};

const makeTarget = DropTarget("ASSET_TYPE", AssetTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}));

CampaignTileDroppable.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
};

export default makeTarget(CampaignTileDroppable);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/CampaignTileDroppable/index.js